import * as yup from 'yup'

// Schema para campos específicos do componente pai BodyModalNewChargeOrRecurrence
export const parentSchema = yup.object({
  customer: yup.object().when(['customerUuid', 'recieverType'], {
    is: (customerUuid: string, recieverType: string) =>
      recieverType === 'customer' && customerUuid === '',
    then: yup
      .object()
      .shape({
        value: yup.string().required('Cliente obrigatório.').nullable(),
        label: yup.string().required('Cliente obrigatório.').nullable()
      })
      .default(null)
      .required(),
    otherwise: yup.object().default(null)
  }),
  group: yup.object().when(['groupUuid', 'recieverType'], {
    is: (groupUuid: string, recieverType: string) =>
      recieverType === 'group' && groupUuid === '',
    then: yup
      .object()
      .shape({
        value: yup.string().required('Grupo obrigatório.').nullable(),
        label: yup.string().required('Grupo obrigatório.').nullable()
      })
      .default(null)
      .required(),
    otherwise: yup.object().default(null)
  }),
  recieverType: yup.string().oneOf(['customer', 'group']).required(),
  customerUuid: yup.string(),
  groupUuid: yup.string()
})
